import axios from "axios";
import { useEffect, useState } from "react";
import { Accordion, Breadcrumb, Col, Container, Row } from "react-bootstrap";
import window11productgroup from "../../../Assets/images/window11 productgroup.png";
import microsoftAuthorizedReseller from "../../../Assets/images/microsoft_authorized_reseller.png";
import { useNavigate } from "react-router-dom";
import { apiBaseURL } from "../../../Common/ApiHelper";
import { ToastContainer, toast } from "react-toastify";

const Window8Pro = ({ id }) => {
  const navigate = useNavigate();
  const [tableData, setTableData] = useState([]);
  const [cart, setCart] = useState([]);
  const [added, setAdded] = useState(
    localStorage.getItem("addedProducts")
      ? localStorage.getItem("addedProducts")
      : []
  );
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    try {
      const response = await axios({
        method: "get",
        url: `${apiBaseURL}user/getProductById/?productId=${id}`,
      });
      if (response?.status === 200) {
        setTableData(response.data.data);
        setLoading(false);
      }
    } catch (e) {
      toast.error(e.message);
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  useEffect(() => {
    if (localStorage.getItem("cartItems")) {
      setCart(JSON.parse(localStorage.getItem("cartItems")));
    } else {
      localStorage.setItem("cartItems", JSON.stringify([]));
    }
  }, []);
  const handleAddCart = (product) => {
    product.quantity = 1;
    localStorage.setItem("cartItems", JSON.stringify([...cart, product]));
    setCart([...cart, product]);
    const updatedArray = JSON.parse(localStorage.getItem("cartItems")).map(
      (items) => items._id
    );
    setAdded(updatedArray);
    localStorage.setItem("addedProducts", JSON.stringify(updatedArray));
    toast.info("Product Added", {
      position: "top-right",
      autoClose: 100,
      hideProgressBar: true,
      closeOnClick: false,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
      theme: "light",
    });
    navigate(`${window.location.pathname}`);
  };
  return (
    <>
      <ToastContainer />
      <div className="main pt-4 pb-5">
        <Container>
          <div className="product_breadcrumb">
            <Breadcrumb>
              <Breadcrumb.Item onClick={() => navigate("/")}>
                Home
              </Breadcrumb.Item>
              <Breadcrumb.Item
                onClick={() => navigate("/category/MicrosoftOffice")}
              >
                Shop
              </Breadcrumb.Item>
              <Breadcrumb.Item active>Windows 8.1 Professional</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          {loading ? (
            <>
              <div class="d-flex justify-content-center ">
                <div class="spinner-grow text-secondary mx-1" role="status">
                  <span class="sr-only"></span>
                </div>
                <div class="spinner-grow text-secondary mx-1" role="status">
                  <span class="sr-only"></span>
                </div>
                <div class="spinner-grow text-secondary mx-1" role="status">
                  <span class="sr-only"></span>
                </div>
                <div class="spinner-grow text-secondary mx-1" role="status">
                  <span class="sr-only"></span>
                </div>
                <div class="spinner-grow text-secondary mx-1" role="status">
                  <span class="sr-only"></span>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="product_details_with_image box_shadow">
                <Row>
                  <Col xxl="3" lg="3" md="12">
                    <div className="product_image pt-4">
                      <img
                        src={tableData.productImage}
                        alt="Product"
                        style={{ width: "100%" }}
                      />
                    </div>
                  </Col>
                  <Col xxl="7" lg="7" md="12">
                    <div className="product_details pt-5 pb-4">
                      <h1>{tableData.name}</h1>
                      <p className="retail_version_color">
                        Retail Version |{" "}
                        {tableData?.retailVersion[0]?.split(":").join(": ")}
                      </p>
                      <img
                        src={window11productgroup}
                        alt="Product inner products images"
                        className="mb-4"
                      />
                      <div className="include_product_purchase">
                        <h1 className="font-weight-bold">
                          Included In Your Purchase:
                        </h1>
                        <p>
                          Download Your Software Directly From Microsoft <br />
                          Activation Key For Windows 8.1 Professional <br />
                          PDF Intructions For Download & Activation <br />
                          Lifetime Live Chat Support & Assistance
                        </p>
                      </div>
                    </div>
                  </Col>
                  <Col xxl="2" lg="2" md="12">
                    <div className="price_details pt-5 pb-4">
                      <p className="font-weight-bold product_price mb-0">
                        ${tableData.salePrice} USD
                      </p>

                      {added.includes(tableData._id) ? (
                        <button
                          className="product_page_addCart_btn box_shadow"
                          onClick={() => navigate("/cart")}
                        >
                          Go To Cart
                        </button>
                      ) : (
                        <button
                          className="product_page_addCart_btn box_shadow"
                          onClick={() => handleAddCart(tableData)}
                        >
                          Add To Cart
                        </button>
                      )}

                      <div className="product_have_questions">
                        <h3>Have Questions?</h3>
                        <p>
                          Call +1 (833) 465 0300 <br /> or contact us via chat
                        </p>
                      </div>
                      <div className="microsoft_partner">
                        <img
                          src={microsoftAuthorizedReseller}
                          alt="productgroupImg"
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </>
          )}
          <div className="extraInfo_tabs mt-4">
            <Row>
              <Col xxl="2" xl="2" lg="4" sm="6">
                <div className="info_tab blue_bg text-center mb-4">
                  <h5>Licensing</h5>
                  <p className="mb-0">Retail</p>
                </div>
              </Col>
              <Col xxl="2" xl="2" lg="4" sm="6">
                <div className="info_tab blue_bg text-center mb-4">
                  <h5>Licensing Term</h5>
                  <p className="mb-0">Lifetime</p>
                </div>
              </Col>
              <Col xxl="2" xl="2" lg="4" sm="6">
                <div className="info_tab blue_bg text-center mb-4">
                  <h5>Users Supported</h5>
                  <p className="mb-0">1 User </p>
                </div>
              </Col>
              <Col xxl="2" xl="2" lg="4" sm="6">
                <div className="info_tab blue_bg text-center mb-4">
                  <h5>Devices Supported</h5>
                  <p className="mb-0">1 Device </p>
                </div>
              </Col>
              <Col xxl="2" xl="2" lg="4" sm="6">
                <div className="info_tab blue_bg text-center mb-4">
                  <h5>Delivery Method</h5>
                  <p className="mb-0">Instant Digital Delivery</p>
                </div>
              </Col>
              <Col xxl="2" xl="2" lg="4" sm="6">
                <div className="info_tab blue_bg text-center mb-4   ">
                  <h5>Platform Supported</h5>
                  <p className="mb-0">Windows</p>
                </div>
              </Col>
            </Row>
          </div>
          <div className="product_long_description">
            <Row>
              <Col xxl="9" md="9" sm="12">
                <div className="box_shadow mb-2 me-3">
                  <div className="product_main_description top_radius">
                    <h3 className="mb-0">Product Description</h3>
                    <p className="mt-4">
                      Sometimes things don’t always work out the way we want,
                      but the important part is learning from your mistakes and
                      doing something about it. Companies try to do
                      groundbreaking and revolutionary things all the time but
                      sometimes they just fall a little short on the execution.
                      Even Microsoft, one of the monsters among corporate
                      powerhouses, falls short of a goal too. They wanted
                      Windows 8 to be a revolutionary step in operating systems,
                      but it just didn’t quite live up to the expectations. In a
                      counter to this problem, they introduced Windows 8.1 to
                      get Windows 8 up to their standards. <br />
                      <br />
                      This version takes Windows 8 to the level where Microsoft
                      originally wanted it to be. It was originally released as
                      a downloadable update for Windows 8 owners. It could also
                      be used to do a clean install on any system the user
                      desired. In comparison to the Windows 7 versions, this 8.1
                      version is comparable to Windows 7 Home Premium. This is a
                      version that your home user wants to use. It gives the
                      user all the awesome technology upgrades, with the
                      benefits of all the things Microsoft improved the software
                      with.
                    </p>
                  </div>

                  <div className="product_grey bottom_radius">
                    <h3 className=" product_details_heading px-4 py-5 mb-0">
                      What's New With Windows 8.1 Pro
                    </h3>
                    <div className="product_grey bottom_radius px-4">
                      <Row>
                        <Col xxl="4" xl="4" lg="12" sm="12">
                          <div>
                            <h5 className="product_description_head my-3">
                              Work Hard. Play Hard.
                            </h5>
                            <div className="underLine_border mb-3"></div>
                            <p className="product_description_p mb-5">
                              Windows 8.1 Pro gives you the power to watch
                              movies, play games, polish your resume, and pull
                              together a killer presentation - all on a single
                              PC.
                            </p>
                          </div>
                        </Col>
                        <Col xxl="4" xl="4" lg="12" sm="12">
                          <div>
                            <h5 className="product_description_head my-3">
                              Start Screen
                            </h5>
                            <div className="underLine_border mb-3"></div>
                            <p className="product_description_p mb-5">
                              Personalize your Start screen with your favorite
                              news, friends, social networks, and apps.
                            </p>
                          </div>
                        </Col>
                        <Col xxl="4" xl="4" lg="12" sm="12">
                          <div>
                            <h5 className="product_description_head my-3">
                              Apps You Want
                            </h5>
                            <div className="underLine_border mb-3"></div>
                            <p className="product_description_p mb-5">
                              Built-in apps for email, contacts, photos, and
                              video editing. Download popular apps like Netflix
                              from the Windows Store.
                            </p>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col xxl="4" xl="4" lg="12" sm="12">
                          <div>
                            <h5 className="product_description_head my-3">
                              Security
                            </h5>
                            <div className="underLine_border mb-3"></div>
                            <p className="product_description_p mb-5">
                              Stay up-to-date and more secure with Windows
                              Defender, Windows Firewall, and Windows Update.
                            </p>
                          </div>
                        </Col>
                        <Col xxl="4" xl="4" lg="12" sm="12">
                          <div>
                            <h5 className="product_description_head my-3">
                              Speed
                            </h5>
                            <div className="underLine_border mb-3"></div>
                            <p className="product_description_p mb-5">
                              Windows 8.1 starts up and swicthes between apps
                              faster then ever and uses power more efficiently
                              than previous versions of Windows.
                            </p>
                          </div>
                        </Col>
                        <Col xxl="4" xl="4" lg="12" sm="12">
                          <div>
                            <h5 className="product_description_head my-3">
                              Familiar Desktop
                            </h5>
                            <div className="underLine_border mb-3"></div>
                            <p className="product_description_p mb-5">
                              From the start screen, you are just a click away
                              from the familiar Windows desktop you know, so you
                              can do the things you've always done.
                            </p>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col xxl="4" xl="4" lg="12" sm="12">
                          <div>
                            <h5 className="product_description_head my-3">
                              Your Office, Your Way.
                            </h5>
                            <div className="underLine_border mb-3"></div>
                            <p className="product_description_p mb-5">
                              Discover new and better ways to create, edit, and
                              browse - using a keyboard, pen, or touchscreen.
                            </p>
                          </div>
                        </Col>
                        <Col xxl="4" xl="4" lg="12" sm="12">
                          <div>
                            <h5 className="product_description_head my-3">
                              Touch
                            </h5>
                            <div className="underLine_border mb-3"></div>
                            <p className="product_description_p mb-5">
                              Windows 8.1 Pro now features touchscreen
                              capabilites on compatiable devices.
                            </p>
                          </div>
                        </Col>
                        <Col xxl="4" xl="4" lg="12" sm="12">
                          <div>
                            <h5 className="product_description_head my-3">
                              Your Files, Anywhere
                            </h5>
                            <div className="underLine_border mb-3"></div>
                            <p className="product_description_p mb-5">
                              Stay connected to your photos and imporant files.
                              Access by using your phone, tablet, or PC with
                              SkyDrive.
                            </p>
                          </div>
                        </Col>
                      </Row>
                      <Row className="pb-5">
                        <Col xxl="4" xl="4" lg="12" sm="12">
                          <div>
                            <h5 className="product_description_head my-3">
                              Keep All Your FIles
                            </h5>
                            <div className="underLine_border mb-3"></div>
                            <p className="product_description_p mb-5">
                              If your PC is running Windows 7, your files, apps,
                              and settings will easily transfer to Windows 8.1
                              Pro.
                            </p>
                          </div>
                        </Col>
                        <Col xxl="4" xl="4" lg="12" sm="12">
                          <div>
                            <h5 className="product_description_head my-3">
                              Keep Familar Programs
                            </h5>
                            <div className="underLine_border mb-3"></div>
                            <p className="product_description_p mb-5">
                              Programs that run on Windows 7 will run on Windows
                              8.1 Pro.
                            </p>
                          </div>
                        </Col>
                        <Col xxl="4" xl="4" lg="12" sm="12">
                          <div>
                            <h5 className="product_description_head my-3">
                              Multitasking Made Easy
                            </h5>
                            <div className="underLine_border mb-3"></div>
                            <p className="product_description_p mb-5">
                              It's easy to do more ar once. Snap multiple apps
                              side by side in a single view for easy
                              multitasking.
                            </p>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
                <div className="product_accordion mt-5 me-3">
                  <Accordion>
                    <Accordion.Item eventKey="0" className=" box_shadow">
                      <Accordion.Header>
                        What is a digital download?
                      </Accordion.Header>
                      <Accordion.Body>
                        A digital download is an electronic version of your
                        software product which gives you access to download and
                        use your software immediately. This means a physical
                        package is not included with your purchase. You will
                        have the option to create a disc or USB at home or in
                        the office. Our support team would be happy to help
                        guide you through the process.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="1" className=" box_shadow">
                      <Accordion.Header>
                        What is the difference between OEM & Retail licenses?
                      </Accordion.Header>
                      <Accordion.Body>
                        OEM licenses are pre-installed on the device and are
                        backed by the vendor. Retail licenses are powered by
                        Microsoft. You are free to install your product on any
                        device. Retail versions may be transferred to new
                        hardware but may only be installed on one device at a
                        time.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="2" className=" box_shadow">
                      <Accordion.Header>
                        How can I guarantee that my copy of Microsoft software
                        is authentic?
                      </Accordion.Header>
                      <Accordion.Body>
                        Liberty Programs only purchases and distributes software
                        and licensing keys through our trusted Microsoft Partner
                        vendors. <br />
                        Any software purchased from Liberty Programs is covered
                        by our hassle-free 90-day money-back guarantee. We
                        encourage all of our customers to register their
                        Microsoft product key via the Microsoft phone activation
                        to ensure authenticity of their purchased products.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="3" className=" box_shadow">
                      <Accordion.Header>
                        Will my license key expire?
                      </Accordion.Header>
                      <Accordion.Body>
                        No, any product purchased from Liberty Programs is a
                        retail version which includes a lifetime license of your
                        software.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="4" className=" box_shadow">
                      <Accordion.Header>
                        How long until I recieve my order?
                      </Accordion.Header>
                      <Accordion.Body>
                        Your order will typically be processed immediately.
                        Please login in to your account area with the
                        credentials given during the checkout process to find
                        your download media and license keys.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="5" className=" box_shadow">
                      <Accordion.Header>
                        How do I download my software?
                      </Accordion.Header>
                      <Accordion.Body>
                        You can access your download media for your purchased
                        software in your account area.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="6" className=" box_shadow">
                      <Accordion.Header>
                        Where can I find the license keys to activate my
                        software
                      </Accordion.Header>
                      <Accordion.Body>
                        You can access your license key for your purchased
                        products in your account area.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="7" className=" box_shadow">
                      <Accordion.Header>
                        How do I get help with my installation?
                      </Accordion.Header>
                      <Accordion.Body>
                        We offer a step-by-step PDF document that walks you
                        through the download process . If you need more
                        assistance please contact our support team and we would
                        be happy to help you with the installation via chat or
                        remote installation.
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
              </Col>
              <Col xxl="3" md="3" sm="12">
                <div className="product_sidebar_widget darkblue_bg box_shadow">
                  <h4>256-bit SSL Encrypted Checkout</h4>
                  <p>
                    All personal information is protected by state of the art
                    SSL certified encryption.{" "}
                  </p>
                  <hr />
                  <h4>24/7 Tech Support Available</h4>
                  <p>
                    Your purchase with Liberty Programs includes around the
                    clock support from our technical experts. <br />
                    <br />
                    Our team of highly trained professionals make software
                    installations a breeze, helping to identify problems and
                    provide immediate solutions that may arise during and after
                    the installation of software.
                  </p>
                  <hr />
                  <h4>Your Business Is Important To Us</h4>
                  <p>
                    We value our customers and appreciate your business with us.
                    <br />
                    <br />
                    Whether you're an individual upgrading your software or a
                    business upgrading their network, we're here 24/7 to provide
                    hands on support and troubleshooting.
                    <br />
                    <br />
                    All software downloads are provided directly from Microsoft
                    with a genuine license key for activation. <br />
                    <br />
                    If you have any concerns regarding the authenticity of your
                    software, please call (833) 465 0300 or contact us via chat
                  </p>
                  <hr />
                  <h4>90-Day Money Back Guarantee</h4>
                  <p>
                    If for any reason you are not completely satisfied with your
                    purchase from us please contact our refund department
                    directly at sales@libertyprograms.com
                    <br />
                    <br />
                    If we cannot resolve your ticket, a full refund will be
                    issued regardless of our 90-day money back guarantee. <br />
                    <br />
                    Terms & conditions apply.
                  </p>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Window8Pro;
